import * as React from 'react';
import './styles-popup.scss';
import { onLoad } from './init';
import { ProtectionPopupApp } from './components/ProtectionPopupApp';

window.onload = () => onLoad(<ProtectionPopupApp />);
